import { render } from 'preact';
import { App } from './app.js';

// Import styles
import './styles/tokens.css';
import './styles/reset.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/spot.css';
import './styles/login.css';
import './styles/console.css';

// Theme is applied from server settings in useSettings hook
// Default to 'dark' until loaded
document.documentElement.setAttribute('data-theme', 'dark');

// Mount app
const root = document.getElementById('app');
if (root) {
  render(<App />, root);
}

// Global error handling
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});
